import { gql } from "apollo-angular";

export const SEARCH_SUGGESTIONS = gql`
    query SearchSuggestions($input: SearchInput!) {
        search(input: $input) {
            items {
                productId
                slug
                productName
                cheapestVariant {
                    id
                    supplierId
                    priceWithTax
                }
                customProductMappings {
                    gtin
                    brand
                }
                productAsset {
                    id
                    preview
                }
            }
        }
    }
`;
